import type { MotionValue } from "motion";

export function createDocumentScrollInput(
  subscribe: (_update: (_y: number, _progress?: number) => void) => () => void,
  read: () => number,
  readProgress: (_y: number) => number = () => 0
) {
  const consumers = new Set<(_y: number, _progress?: number) => void>();
  let stop: (() => void) | undefined;
  return (
    target: MotionValue<number>,
    progressTarget?: MotionValue<number>
  ) => {
    // Sample at mount, not from a potentially stale previous route's value.
    const y = read();
    target.jump(y);
    if (progressTarget) progressTarget.jump(readProgress(y));
    const update = (position: number, progress?: number) => {
      target.set(position);
      if (progress !== undefined) progressTarget?.set(progress);
    };
    consumers.add(update);
    stop ??= subscribe((position, progress) => {
      for (const consumer of consumers) consumer(position, progress);
    });
    return () => {
      if (!consumers.delete(update)) return;
      if (!consumers.size) {
        stop?.();
        stop = undefined;
      }
    };
  };
}
